import FBtnMDP from "@/components/FBtnMDP";
import FPaymentActionStatusBtnMDP from "@/components/FPaymentActionStatusBtnMDP";
import FFormDrawerMDP from "@/components/form/FFormDrawerMDP";
import FFormMDP from "@/components/form/FFormMDP"

export default class PaymentDetailsInfoFFormMDP extends FFormDrawerMDP {
    parent: any;
    constructor(props: {parent: any;}) {
        super({
            myRefName: "PaymentDetailsInfoRef",
            isVisible: false,
            onClose: () => {}
        });
        this.parent = props.parent;

        this.addAction(new FPaymentActionStatusBtnMDP({
            onClick: () => {},
            paymentId: this.parent?.selectedPaymentSummaryToView?.paymentId,
            paymentStatus: this.parent?.selectedPaymentSummaryToView?.status,
        }))
    }
}